/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_section_what_we_build = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What We Build`)
};

const es_about_section_what_we_build = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué construimos`)
};

const de_about_section_what_we_build = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was wir bauen`)
};

const nl_about_section_what_we_build = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat we bouwen`)
};

const fr_about_section_what_we_build = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce que nous construisons`)
};

const it_about_section_what_we_build = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa costruiamo`)
};

const pt_br2_about_section_what_we_build = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que construímos`)
};

const pt_about_section_what_we_build = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que construímos`)
};

const ja_about_section_what_we_build = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私たちが作るもの`)
};

const zh_about_section_what_we_build = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们构建的内容`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_section_what_we_build = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_section_what_we_build(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_section_what_we_build", locale)
	if (locale === "en") return en_about_section_what_we_build(inputs)
	if (locale === "es") return es_about_section_what_we_build(inputs)
	if (locale === "de") return de_about_section_what_we_build(inputs)
	if (locale === "nl") return nl_about_section_what_we_build(inputs)
	if (locale === "fr") return fr_about_section_what_we_build(inputs)
	if (locale === "it") return it_about_section_what_we_build(inputs)
	if (locale === "pt-BR") return pt_br2_about_section_what_we_build(inputs)
	if (locale === "pt") return pt_about_section_what_we_build(inputs)
	if (locale === "ja") return ja_about_section_what_we_build(inputs)
	return zh_about_section_what_we_build(inputs)
};